<template>
  <div class="bg-cream">
  <Nav color="blue" :init-banner-state="true"></Nav>
  <section id="hero" class="container-large">
      <div class="hero-container">
        <video class="" autoplay muted loop>
            <source src="../assets/img/header-video.mp4" type="video/webm" />
        </video>
      </div>
  </section>
    <section id="browse-product">
      <div class="bottom-line blue container-large"></div>
      <div class="blue centered uppercase container-mid">
        <p class="poppins-segment">Step into our unique stories told through <b>cross-media </b> games, books and postcards!</p>
<!--        <img class="drawing" src="../assets/img/icon_browse.png">-->
      </div>
      <div class="product-grid container-large mt-2">
        <ProductLearnMore v-for="product in featuredInteractiveStories" v-bind:key="product.name" :product="product"></ProductLearnMore>
      </div>
      <div class="container-large centered">
        <button class="dark full title" @click="goToShop">Shop our interactive products</button>
      </div>
    </section>
    <section id="cross-media-games" class="container-mid mb-6">
      <div class="centered mt-2">
         <img class="drawing" src="../assets/img/icon_cross-media.png">
      </div>
      <div>
        <h2 class="blue centered">What makes our games special?</h2>

        <div class="">
           <p class="uppercase subtitle centered width-80">We make cross-media narrative boardgames for families, blending physical play and digital interactions.</p>
          <div id="cross-media-text" class="col container">
            <div class="row storybit">
              <img src="../assets/img/CM_MARSHMALLOW.png">
              <p class="large-text">Imagine you are reading a book about a group of friends going camping. They brought everything to make roasted marshmallows, but they forgot the matches for the fire…</p>
            </div>
             <div class="row storybit">
              <img src="../assets/img/CM_DRAGON.png">
              <p class="large-text">You draw a dragon on the page, and your dragon comes to life, and breathes fire onto the marshmallows…</p>
            </div>
            <div class="row storybit">
              <img src="../assets/img/CM_ROASTED.png">
              <p class="large-text"> Both the marshmallows and the page are now a little burnt.</p>
            </div>
            <p class="large-text highlight-text teal"><strong>Wouldn’t that be pretty <span class="blue">awesome</span>?</strong></p>
            <p class="large-text">Combining physical mediums, like books, postcards, board games, with digital ones, like an augmented reality app can open new ways of <span class="bold underlined">interacting with stories.</span></p>
            <p class="large-text">Each of our products has uniquely crafted interactions between multiple mediums, bringing joy and magic to your family’s story and game time.</p>
            <img id="cross-media-img" src="../assets/img/cross-media.png">

          </div>
        </div>
      </div>

    </section>
    <section id="try-it-home">
      <div class="container-mid row gap-2 mt-3 mb-3">
        <div class="width-50 mb-2 align-self-end">
          <img class="drawing" src="../assets/img/icon_try-home.png">
          <h2 class="cream">Try it at home!</h2>
          <div class="width-80 cream">
            <p>Curious about our cross-media games? Here is a little teaser for you (or your little humans)!</p>
            <p>Download one of these activity sheets and draw something on it to shelter the little critters from the rain.
            You can be as creative as you’d like — an umbrella, a UFO… anything works.</p><p>Then, use our free app <router-link to="/hidden-app-redirect" class="cream">Hidden: Augmented Reality Postcards</router-link> (QR code on the sheet) to watch your drawing come to life with cute animations!</p>
          </div>
        </div>
        <div id="downloadables" class="grid grid-2 width-40">
          <div class="pointer" @click="downloadActivitySheet('raccoon')">
          <img src="../assets/img/activity-sheet_thumbnail_raccoon.jpg">
          <button class="full black button-secondary">Download</button>
        </div>
        <div class="pointer" @click="downloadActivitySheet('mouse')">
          <img src="../assets/img/activity-sheet_thumbnail_mouse.jpg">
          <button class="full black button-secondary">Download</button>
        </div>
        </div>

      </div>
    </section>
   <FullPreFooter></FullPreFooter>
  <Footer :borderTop=false></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Nav from "@/components/Nav";
import router from "../router/index.js";
import ProductLearnMore from "@/components/ProductLearnMore";
import FullPreFooter from "@/components/FullPreFooter.vue";


export default {
  name: 'Home',
  components: {
    FullPreFooter,
    ProductLearnMore,
    Footer,
    Nav
  },
  data () {
    return {
      isCompact: false,
      isMobile: false,
      cardHover : false,
      currentCardNumber: '-1',
      featuredInteractiveStories: [
          {
            projectName: 'The Mysteries of Tosola',
            subtitle: 'A cross-media detective story ',
            heroImg: 'TOSOLA_HERO.png',
            tag: 'coming-soon',
            link: '/tosola'
          },
          {
            projectName: 'The Bear Who Touched The Northern Lights',
            subtitle: 'A story-driven puzzle',
            heroImg: 'BEAR_HERO.png',
            tag: 'bestseller',
            link: '/tbwttnl'
          },
          {
            projectName: 'Dancing Shadows',
            subtitle: 'Shadow pop-up books',
            heroImg: 'DANCINGSHADOWS_HERO.png',
            link: '/product/dancing-shadows-umbras-halloween-party'
          },
          {
            projectName: 'Hidden: Augmented Reality Postcards',
            subtitle: 'Postcards that come to life',
            heroImg: 'HIDDEN_HERO.png',
            link: '/product/hidden-s2e1'
          }
      ]
    }
  },
  methods: {
    resizeHandler() {
      this.isCompact = window.innerWidth < 1024;
      this.isMobile = window.innerWidth < 769;
    },
    downloadActivitySheet(type) {
      switch (type) {
        case 'mouse':
          window.open('/pdfs/activity-sheet_mouse.pdf', '_blank');
          break;
        case 'raccoon':
          window.open('/pdfs/activity-sheet_raccoon.pdf', '_blank');
          break
      }
    },
    triggerMobileMenu(state) {
      this.mobileMenu = state;
    },
    cardHovered(cardNb, state) {
      this.cardHover = state;
      if (state)
        this.currentCardNumber = cardNb;
      else
        this.currentCardNumber = -1;
    },
    productPage() {
      router.push({name: 'TheBearWhoTouchedTheNorthernLights'});
    },
    goToShop() {
      router.push({name: 'shop'});
    }
  },
  computed: {
    products() {
      return this.$store.getters.getFeaturedProducts;
    },
  },
  created() {
    this.isCompact = window.innerWidth < 1068;
    this.isMobile = window.innerWidth < 769;
    window.addEventListener("resize", this.resizeHandler);

    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

}
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

#hero {
  z-index: 700;
  border-top: 1px solid $blue;
  margin-top: 8rem;
  padding-bottom: 2rem;

  video {
    width: 100%;
  }

  .hero-container {
    //margin: 3em 0 4em 0;
  }

  .row {
    align-items: flex-end;
    align-content: center;
    height: 80%;
    margin-bottom: 20%;
  }

  .left {
    flex-basis: 45%;
    padding-bottom: 2rem;
    /*height: 100%;*/
    align-content: center;
  }
  .right {
    flex-basis: 50%;
  }

  p.subtitle {
    padding-right: 2em;
  }
}

#browse-product {
  position: relative;
  margin-bottom: 6em;
  img.drawing {
    //position: absolute;
    //z-index: 3;
    //top: -50px;
    //right: 0;
  }
  .product-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1em;
    align-items: stretch;

    .card-container-outline {
      margin: 0;
    }
  }


  button {
    margin: 1em 0;
    padding: 1.5em 0;
    border-radius: 30px;
    color: $teal;

    &.title {
      font-size: 1.4rem;

    }
  }
}

.justify-end {
  justify-content: flex-end;
}

#try-it-home {
  background-color: $hidden-mid-red;
  padding: 2em 0;
  border-top: 1px solid $blue-hover;
  border-bottom: 1px solid $blue-hover;
}

#downloadables {
  align-self: flex-end;
}

#cross-media-games {
  .subtitle {
    margin: 2em auto 0 auto;
  }
}

#cross-media-text {
  margin: 4em auto;
  max-width: 80%;

  .storybit {
    gap: 2em;
    align-items: center;
    margin: 1em 0;

    img {
      max-width: 20%;
    }

    p.large-text {
      max-width: calc(80% - 2em);
      padding-bottom: 0;
    }
  }

  .highlight-text {
    text-align: center;
    font-size: 1.8em;
    margin: 2em 0;
  }

  #cross-media-img {
    max-width: 700px;
    width: 100%;
    margin: 2em auto;
    align-self: center;
  }
}

@media only screen and (max-width: 1023px) {
  #try-it-home {
    .width-50, .width-40, .width-80 {
      width: unset;
    }
  }
}

@media only screen and (max-width: 747px) {

  #cross-media-games {
    .width-80 {
      width: unset;
    }
  }

  #cross-media-text {
    max-width: 100%;

    .storybit {
      p.large-text {
        max-width: 100%;
      }
      img {
        max-width: 40%;
        text-align: center;
        margin: auto;
      }
    }
  }

  #try-it-home {
    .grid-2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  #browse-product {

    .product-grid {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 1em;

      .card-container-outline {
        margin: 0;
      }
    }
    }
}

</style>